import React, { FC, useState } from 'react';
import {
  createStyles,
  Grid,
  makeStyles,
  Theme,
  Typography,
} from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import { IBusiness } from '../utils/utils';
import EditBusinessBankModal from './Modals/EditBusinessBankModal';

interface Params {
  editable?: boolean;
  businessState: IBusiness;
  setBusinessState: React.Dispatch<React.SetStateAction<IBusiness>>;
}

const BusinessEditBank: FC<Params> = (props) => {
  const { editable, businessState, setBusinessState } = props;
  const classes = useStyles();
  const [openModal, setOpenModal] = useState(false);

  const handleEdit = () => {
    setOpenModal(true);
  };

  const handleClose = () => {
    setOpenModal(false);
  };

  return (
    <>
      <Grid item xs={12} sm={4} className={classes.left}>
        <Typography className={classes.label}>Banque (prêteur) :</Typography>
      </Grid>
      <Grid item xs={11} sm={7} className={classes.left}>
        <Typography>{businessState.bank?.name || ''}</Typography>
      </Grid>
      <Grid item xs={1} sm={1} className={classes.right}>
        {editable && <EditIcon className={classes.icon} onClick={handleEdit} />}
      </Grid>
      {openModal && (
        <EditBusinessBankModal
          businessState={businessState}
          setBusinessState={setBusinessState}
          handleClose={handleClose}
        />
      )}
    </>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    left: {
      display: 'flex',
      justifyContent: 'left',
      alignItems: 'center',
    },
    label: {
      fontWeight: 'bold',
    },
    right: {
      display: 'flex',
      justifyContent: 'right',
      alignItems: 'center',
    },
    icon: {
      height: 15,
      color: '#FF4340',
      cursor: 'pointer',
    },
    input: {
      flex: 1,
    },
    disabled: {
      color: 'black',
    },
  }),
);

export default BusinessEditBank;
